namespace('IO.Views.Packages', function (exports) {
  'use strict';

  exports.New = IO.Views.Packages.Show;
});
